import { type BaseItem, type NullablePartial } from './common.js';

export enum FeedMessageFormat {
  X12 = 'X12',
  HL7 = 'HL7',
  JSON = 'JSON',
}

export enum FeedMessageStatus {
  Success = 'Success',
  Filtered = 'Filtered',
  Error = 'Error',
}

interface BaseFeedMessage {
  feedId: string;
  practiceId: string;
  source: string;
  rawMessageFormat: FeedMessageFormat;
  rawMessage: string;
  parsedMessage: Record<string, any> | null;
  patientOrderId: string | null;
  ehrInformationId: string | null;
  encounterId: string | null;
  mirthChannelId: string | null;
  mirthMessageId: number | null;
  status: FeedMessageStatus | null;
  errorReason: string | null;
  feedApiPayload: Record<string, any> | null;
}

export type FeedMessage = BaseItem & BaseFeedMessage;
export type SafeFeedMessage = Omit<
  FeedMessage,
  'rawMessage' | 'parsedMessage' | 'errorReason' | 'feedApiPayload'
>;
export type CreateValues = NullablePartial<BaseFeedMessage>;

export interface FindAllOptions {
  messageFormat?: FeedMessageFormat;
  createdAfter?: string;
  createdBefore?: string;
  limit?: number;
  page?: number;
  feedId: string;
  status?: FeedMessageStatus;
  practiceId?: string;
  mirthMessageId?: string;
  mirthChannelId?: string;
  source?: string;
}

export function isFeedMessage(object: any): object is FeedMessage {
  return 'rawMessage' in object;
}

export function isSafeFeedMessage(object: any): object is SafeFeedMessage {
  return 'feedId' in object && !('rawMessage' in object);
}
